module.exports = __webpack_public_path__ + "static/media/nina.5a4ec464.jpg";